import { useStorage } from '@vueuse/core'
import { createI18n } from 'vue-i18n'
import { useLocale } from 'vuetify'
import {
    pluralizationRules,
    fallbackLocale,
} from '@/configs/i18nTranslations/i18n.partial-config'
import messages from '@/configs/i18nTranslations/translations.json'

export const userLocale = useStorage('user-locale', 'fr')

export const i18nPlugin = createI18n({
    legacy: false as const,
    globalInjection: true,
    locale: userLocale.value,
    missingWarn: false,
    fallbackWarn: false,
    pluralRules: pluralizationRules,
    fallbackLocale,
    messages,
})

const i18n = i18nPlugin.global

export const $t: typeof i18n.t = i18n.t.bind(i18n)

export const $locale = () => i18n.locale.value

export function useI18nPlugin() {
    const { current } = useLocale()

    return {
        locale: computed(() => i18n.locale.value),
        updateLocale(locale: 'fr' | 'en') {
            i18n.locale.value = locale
            current.value = locale
            userLocale.value = locale
        },
    }
}
